import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToCTA = () => {
    const ctaSection = document.getElementById('cta-final');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full min-h-screen gradient-purple overflow-hidden" data-id="element-157">
      {/* Decorative moon phases background */}
      <div className="absolute inset-0 opacity-10" data-id="element-158">
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-white/20 moon-glow" data-id="element-159" />
        <div className="absolute top-40 right-20 w-24 h-24 rounded-full bg-white/15" data-id="element-160" />
        <div className="absolute bottom-32 left-1/4 w-20 h-20 rounded-full bg-white/10" data-id="element-161" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-163">
          {/* Emotional hook */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 1
        }} className="text-lavender-light text-lg sm:text-xl md:text-2xl font-light italic mb-6 leading-relaxed max-w-4xl mx-auto" data-id="element-164">
            3am. Sudas empapada. No es calor —es tu cuerpo gritando por ayuda
            que nadie explica en español.
          </motion.p>

          {/* Main headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold font-heading mb-4 text-shadow-soft" data-id="element-165">
            Tu Calendario{' '}
            <span className="font-script text-cream" data-id="element-166">"Fases Lunares"</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9,
          duration: 0.8
        }} className="text-lavender-light text-2xl sm:text-3xl md:text-4xl font-heading font-semibold mb-12" data-id="element-167">
            para Mamás Latinas 40+
          </motion.p>

          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 1.2,
          duration: 0.8
        }} className="mb-12 flex justify-center" data-id="element-168">
            <img src="https://cdn.magicpatterns.com/uploads/iXf1dxqJoLTQS4VXfKWFrM/fases_lunares.png" alt="Plantillas Menopausia Sin Drama - Calendario Fases Lunares" className="w-full max-w-2xl rounded-2xl shadow-2xl moon-glow" data-id="element-169" />
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.5,
          duration: 0.8
        }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-170">
            <button onClick={scrollToCTA} className="group relative px-10 py-5 bg-coral hover:bg-terracotta text-white text-xl font-bold rounded-full shadow-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl" data-id="element-171">
              <span className="flex items-center gap-3" data-id="element-172">
                <SparklesIcon className="w-6 h-6" data-id="element-173" />
                COMPRAR AHORA
              </span>
            </button>
            <p className="text-lavender-light text-sm" data-id="element-174">
              Descarga instantánea • PDF + Canva
            </p>
          </motion.div>

          {/* Trust indicators */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.8,
          duration: 0.8
        }} className="mt-12 flex flex-wrap justify-center gap-8 text-lavender-light text-sm" data-id="element-175">
            <div className="flex items-center gap-2" data-id="element-176">
              <MoonIcon className="w-5 h-5" data-id="element-177" />
              <span data-id="element-178">50+ mamás lo usan</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-179">
              <SparklesIcon className="w-5 h-5" data-id="element-180" />
              <span data-id="element-181">70% menos interrupciones</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-182">
              <MoonIcon className="w-5 h-5" data-id="element-183" />
              <span data-id="element-184">Resultados en 28 días</span>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-185">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-186">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white" data-id="element-187" />
        </svg>
      </div>
    </section>;
}